module.exports = __webpack_public_path__ + "img/example-jpg.629be63e.svg";